var _g, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path6, _path7, _path8, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 152,
    viewBox: "0 0 287 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13083_16002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.9539,
    cy: 112.954,
    r: 32,
    transform: "rotate(-12 37.9539 112.954)",
    fill: "#FFC844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.211 97.1644C33.451 95.8801 35.1226 95.5247 35.8642 96.6004L41.049 104.121C41.3616 104.574 41.9017 104.815 42.4479 104.744L51.5059 103.565C52.8015 103.396 53.656 104.876 52.8621 105.914L47.312 113.169C46.9774 113.606 46.9156 114.194 47.152 114.691L51.0724 122.942C51.6332 124.122 50.4896 125.392 49.2574 124.958L40.6425 121.921C40.123 121.738 39.5447 121.861 39.1446 122.239L32.5096 128.517C31.5605 129.415 29.9993 128.72 30.0316 127.414L30.2574 118.283C30.271 117.732 29.9754 117.22 29.4917 116.956L21.4707 112.586C20.3233 111.961 20.502 110.261 21.7542 109.888L30.5086 107.281C31.0365 107.124 31.4321 106.685 31.5333 106.143L33.211 97.1644Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143 96C169.51 96 191 74.5097 191 48C191 21.4903 169.51 0 143 0C116.49 0 95 21.4903 95 48C95 74.5097 116.49 96 143 96Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175 149C201.51 149 223 127.51 223 101C223 74.4903 201.51 53 175 53C148.49 53 127 74.4903 127 101C127 127.51 148.49 149 175 149Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175 120C203.719 120 227 96.7188 227 68C227 39.2812 203.719 16 175 16C146.281 16 123 39.2812 123 68C123 96.7188 146.281 120 175 120Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126 151C148.091 151 166 133.091 166 111C166 88.9086 148.091 71 126 71C103.909 71 86 88.9086 86 111C86 133.091 103.909 151 126 151Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120 121C148.719 121 172 97.7188 172 69C172 40.2812 148.719 17 120 17C91.2812 17 68 40.2812 68 69C68 97.7188 91.2812 121 120 121Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 199,
    cy: 4,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 57,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 10,
    r: 3,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 140,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 280.5,
    cy: 89.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 150.5,
    r: 1.5,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M227 15L245.5 7.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54 32.5L27 26.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M257 114L285 120.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13083_16002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 46.0012,
    r: 20,
    transform: "rotate(10 258 46.0012)",
    fill: "#FFC844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.948 35.7412C259.388 35.0531 260.44 35.2386 260.618 36.0356L261.861 41.6074C261.936 41.9434 262.193 42.2092 262.526 42.2959L268.051 43.7334C268.842 43.939 268.99 44.9967 268.287 45.4122L263.373 48.3169C263.076 48.4921 262.903 48.8183 262.923 49.162L263.263 54.8608C263.312 55.6759 262.352 56.1442 261.74 55.604L257.458 51.8273C257.2 51.5996 256.836 51.5354 256.516 51.6611L251.201 53.7457C250.441 54.0439 249.699 53.2756 250.023 52.5262L252.292 47.2874C252.429 46.9715 252.378 46.6056 252.159 46.3397L248.534 41.9292C248.016 41.2983 248.517 40.3552 249.33 40.4323L255.013 40.9712C255.356 41.0037 255.688 40.8417 255.874 40.5516L258.948 35.7412Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_13083_16002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 95.0002,
    cy: 37.9986,
    r: 20,
    transform: "rotate(-10 95.0002 37.9986)",
    fill: "#FFC844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.382 28.0327C92.5599 27.2357 93.6118 27.0502 94.0516 27.7383L97.126 32.5487C97.3114 32.8388 97.6435 33.0008 97.9863 32.9683L103.67 32.4294C104.483 32.3523 104.984 33.2954 104.466 33.9262L100.841 38.3367C100.622 38.6027 100.571 38.9686 100.708 39.2845L102.976 44.5233C103.301 45.2726 102.559 46.041 101.799 45.7428L96.4839 43.6582C96.1634 43.5325 95.7995 43.5967 95.5413 43.8244L91.2601 47.601C90.6477 48.1412 89.6876 47.673 89.7363 46.8579L90.0765 41.159C90.097 40.8154 89.9236 40.4891 89.6272 40.314L84.7124 37.4093C84.0094 36.9938 84.158 35.9361 84.9483 35.7305L90.4734 34.293C90.8066 34.2063 91.0632 33.9405 91.1382 33.6045L92.382 28.0327Z",
    fill: "#24284E"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_13083_16002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 213.001,
    cy: 108.003,
    r: 28,
    transform: "rotate(10 213.001 108.003)",
    fill: "#FFC844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.328 93.6389C214.944 92.6756 216.417 92.9352 216.666 94.051L218.407 101.852C218.512 102.322 218.871 102.694 219.338 102.815L227.073 104.828C228.179 105.116 228.387 106.597 227.403 107.178L220.522 111.245C220.107 111.49 219.865 111.947 219.893 112.428L220.37 120.406C220.438 121.548 219.094 122.203 218.236 121.447L212.243 116.159C211.881 115.841 211.372 115.751 210.923 115.927L203.482 118.845C202.418 119.263 201.379 118.187 201.834 117.138L205.01 109.804C205.202 109.361 205.13 108.849 204.823 108.477L199.749 102.302C199.023 101.419 199.725 100.098 200.863 100.206L208.82 100.961C209.3 101.006 209.764 100.78 210.024 100.373L214.328 93.6389Z",
    fill: "#24284E"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_13083_16002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 76,
    r: 52,
    fill: "#FFC844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.972 46.734C136.252 44.6294 138.935 43.9106 140.23 45.5932L148.723 56.6283C149.269 57.3376 150.166 57.6819 151.046 57.52L164.742 55.0024C166.83 54.6185 168.342 56.9476 167.142 58.6991L159.272 70.1865C158.766 70.9249 158.716 71.8843 159.142 72.6715L165.768 84.9187C166.779 86.7861 165.031 88.9443 162.994 88.3443L149.637 84.4088C148.778 84.1559 147.85 84.4045 147.233 85.0529L137.633 95.1397C136.17 96.6777 133.577 95.6825 133.518 93.5601L133.133 79.6404C133.109 78.7457 132.585 77.94 131.778 77.5535L119.218 71.5403C117.303 70.6234 117.449 67.8501 119.449 67.1385L132.569 62.4711C133.412 62.1711 134.016 61.4245 134.135 60.5372L135.972 46.734Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.443 71.3054C172.045 68.3191 168.239 67.2992 166.401 69.6867L161.549 75.9913C161.232 76.4035 160.711 76.6035 160.199 76.5095L152.375 75.0711C149.412 74.5264 147.265 77.8312 148.968 80.3165L153.465 86.8797C153.759 87.3087 153.788 87.8662 153.54 88.3236L149.754 95.3208C148.321 97.9705 150.801 101.033 153.691 100.181L161.322 97.933C161.821 97.786 162.36 97.9305 162.719 98.3072L168.203 104.07C170.28 106.252 173.959 104.84 174.043 101.829L174.262 93.876C174.277 93.3561 174.581 92.888 175.05 92.6634L182.226 89.2279C184.943 87.9269 184.737 83.9917 181.898 82.982L174.403 80.3153C173.913 80.141 173.561 79.7072 173.493 79.1916L172.443 71.3054Z",
    fill: "white",
    stroke: "#FFC844",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13083_16002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 88.3066) rotate(-12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13083_16002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(241.776 22.832) rotate(10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_13083_16002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(71.8311 21.7754) rotate(-10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_13083_16002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(190.288 75.5664) rotate(10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_13083_16002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white",
    transform: "translate(100 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPoints);
export default __webpack_public_path__ + "static/media/total-points.8371df9ce30430d952ee85108f0d472f.svg";
export { ForwardRef as ReactComponent };